import menu from './menu'
import { inArrayMult } from '@/service/util'
import store from '@/store'

const state = {
  menu,
  permissoes: {}
}

const getters = {
  menuPermitido: state => {
    let menu = []
    let ehRoot = store.getters['auth/root']
    state.menu.forEach(item => {
      if (item.sub) {
        let filhos = []
        item.sub.forEach(filho => {
          if ((inArrayMult(state.permissoes, filho.meta.rules) && (!filho.meta.root || (filho.meta.root && ehRoot))) ||
               (filho.id === 'relatorio-usuarios-comercial' && store.state.auth.usuario.vendedor)) filhos.push(filho)
          // filhos.push(filho)
        })
        if (filhos.length > 0) {
          item.sub = filhos
          menu.push(item)
        }
      } else {
        if (inArrayMult(state.permissoes, item.meta.rules) && (!item.meta.root || (item.meta.root && ehRoot)) && !(store.state.auth.usuario.unidade.padrao && item.id === 'promotora')) menu.push(item)
      }
    })
    return menu
  },
  primeiraTela: state => {
    let ehRoot = store.getters['auth/root']
    let tela = false
    for (let x = 0; x < state.menu.length && !tela; x++) {
      if (state.menu[x].sub) {
        let filho = state.menu[x].sub
        for (let y = 0; y < filho.length && !tela; y++) {
          if ((inArrayMult(state.permissoes, filho[y].meta.rules) && (!filho[y].meta.root || (filho[y].meta.root && ehRoot))) ||
            (filho[y].id === 'relatorio-usuarios-comercial' && store.state.auth.usuario.vendedor)) tela = filho[y]
        }
      } else {
        if (inArrayMult(state.permissoes, state.menu[x].meta.rules) && (!state.menu[x].meta.root || (state.menu[x].meta.root && ehRoot))) tela = state.menu[x]
      }
    }
    return tela
  }
}

const mutations = {
  SETPERMISSOES (state, payload) {
    state.permissoes = payload ? payload.map(e => e.identificacao) : []
  }
}

const actions = {
  setPermissoes ({ commit }, payload) {
    commit('SETPERMISSOES', payload)
  },
  valida ({ state }, rules) {
    if (rules.length) return inArrayMult(state.permissoes, rules)
    return true
  }
}

export default { namespaced: true, getters, state, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/acesso/index.js